import { Result, Button } from "antd";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps): JSX.Element {
  return (
    <Result
      status="error"
      title={error.message}
      subTitle="Sorry, something went wrong."
      extra={
        <Button size="large" type="primary" onClick={resetErrorBoundary}>
          Try again
        </Button>
      }
    />
  );
}

export default ErrorFallback;
